import { render } from "./activity-import.vue?vue&type=template&id=36664784"
import script from "./activity-import.vue?vue&type=script&lang=js"
export * from "./activity-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__